import useResizeObserver from '@react-hook/resize-observer';
import * as React from 'react';
export const useSize = (target) => {
    const [size, setSize] = React.useState(undefined);
    React.useEffect(() => {
        if (target.current) {
            setSize(target.current.getBoundingClientRect());
        }
    }, [target]);
    useResizeObserver(target.current, (entry) => {
        setSize(entry.target.getBoundingClientRect());
    });
    return size;
};
//# sourceMappingURL=use-size.js.map